import { Component, Input } from '@angular/core';

export type StatusBadgeTone = 'success' | 'warning' | 'error' | 'neutral';

@Component({
  standalone: false,
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss'],
})
export class StatusBadgeComponent {
  @Input({ required: true }) label: string;
  @Input() tone: StatusBadgeTone = 'success';
  /** Screen-reader-only prefix, e.g. "Status: ". */
  @Input() srLabel: string | null = null;
  /** Shows this Material icon instead of the visible label. The label stays available to screen readers. */
  @Input() icon: string | null = null;
  @Input() iconOnly: boolean = false;
}
